// extracted by mini-css-extract-plugin
export default {"cls1":"aEKloYSskwKNspPuCrkf","cls2":"iflipSvOT5j0ekSepa6h aEKloYSskwKNspPuCrkf"};